// frontend/src/pages/LoginPage.jsx
import React, { useState } from 'react';
import { API_URL } from '../utils/api';

export default function LoginPage({ onAuthSuccess, switchToSignup, switchToForgot }) {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError(null);
    setLoading(true);
    try {
      const res = await fetch(`${API_URL}/api/auth/login`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email, password }),
      });
      const data = await res.json();
      if (!res.ok) throw new Error(data?.error || 'Login failed');
      localStorage.setItem('authToken', data.token);
      localStorage.setItem('user', JSON.stringify(data.user));
      onAuthSuccess(data.user, data.token);
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="max-w-md mx-auto mt-10 p-6 bg-white shadow rounded">
      <h2 className="text-2xl font-semibold mb-4">Log in</h2>
      <form onSubmit={handleSubmit} className="space-y-4">
        <div>
          <label className="block text-sm mb-1">Email</label>
          <input className="w-full border rounded p-2" type="email" value={email} onChange={(e) => setEmail(e.target.value)} required />
        </div>
        <div>
          <label className="block text-sm mb-1">Password</label>
          <input className="w-full border rounded p-2" type="password" value={password} onChange={(e) => setPassword(e.target.value)} required />
        </div>
        <div className="text-right text-sm">
          <button type="button" className="text-blue-600 underline" onClick={switchToForgot}>
            Forgot password?
          </button>
        </div>
        {error && <div className="text-red-600 text-sm">{error}</div>}
        <button type="submit" className="w-full bg-blue-600 text-white py-2 rounded" disabled={loading}>
          {loading ? 'Logging in...' : 'Log in'}
        </button>
      </form>
      <div className="text-sm mt-4">
        No account?{' '}
        <button className="text-blue-600 underline" onClick={switchToSignup}>Sign up</button>
      </div>
      <div className="text-sm mt-6 text-center flex flex-col sm:flex-row sm:justify-center gap-3">
        <a
          href="https://autolistify.com/privacy-policy/"
          target="_blank"
          rel="noopener noreferrer"
          className="text-blue-600 underline"
        >
          Privacy Policy
        </a>
        <a
          href="https://autolistify.com/terms-of-service/"
          target="_blank"
          rel="noopener noreferrer"
          className="text-blue-600 underline"
        >
          Terms of Service
        </a>
      </div>
    </div>
  );
}
